import React from 'react';

const TeacherIcon: React.FC = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M15.3169 10.7002V14.8085C15.3169 15.8669 14.4919 17.0002 13.5003 17.3335L10.8419 18.2169C10.3753 18.3752 9.61693 18.3752 9.15859 18.2169L6.50026 17.3335C5.50026 17.0002 4.68359 15.8669 4.68359 14.8085L4.69193 10.7002L8.37526 13.1002C9.27526 13.6919 10.7586 13.6919 11.6586 13.1002L15.3169 10.7002Z"
      fill="#6fe6a7"
    />
    <path
      d="M16.6503 5.3833L11.6586 2.1083C10.7586 1.51663 9.27526 1.51663 8.37526 2.1083L3.35859 5.3833C1.75026 6.42497 1.75026 8.7833 3.35859 9.8333L4.69193 10.7L8.37526 13.1C9.27526 13.6916 10.7586 13.6916 11.6586 13.1L15.3169 10.7L16.4586 9.94997V12.5C16.4586 12.8416 16.7419 13.125 17.0836 13.125C17.4253 13.125 17.7086 12.8416 17.7086 12.5V8.39997C18.0419 7.32497 17.7003 6.07497 16.6503 5.3833Z"
      fill="#6fe6a7"
    />
  </svg>
);

export default TeacherIcon;
